/* eslint-disable no-shadow */
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import { HttpError, PMSError, ValidationError } from '@/errors';
import { router } from '@/router';

const endpoint = `${apiEndpoint}/reports`;

const state = {
  properties: [],
  users: [],
  pages: [],
  reports: null,
  pending: false,
  error: null,
};

const getters = {
  pages: (state) => (state.pages ?? []),
  properties: (state) => (state.properties ?? []),
  users: (state) => (state.users ?? []),
  reports: (state) => (state.reports ?? null),
};

const mutations = {
  clearErrors(state) {
    state.error = null;
  },
  beforeReportsLoading(state, initial = false) {
    if (initial) {
      state.reports = [];
    }
    state.error = null;
    state.pending = true;
  },
  beforePagesLoading(state, initial = false) {
    if (initial) {
      state.pages = [];
    }
    state.error = null;
    state.pending = true;
  },
  reports(state, { data = [], error = null } = {}) {
    state.pending = false;
    state.reports = data;
    state.error = error;
  },
  properties(state, { data = [], error = null } = {}) {
    state.pending = false;
    state.properties = data;
    state.error = error;
  },
  users(state, { data = [], error = null } = {}) {
    state.pending = false;
    state.users = data;
    state.error = error;
  },
  getPages(state) {
    // Get all pages from vue router
    const pages = [];
    router.options.routes.forEach((item) => {
      item.children.forEach((subItem) => {
        if (subItem.name && subItem?.meta?.loadMeasurement) {
          pages.push({
            name: subItem.name,
          });
        }
      });
    });
    state.pages = pages;
  },
};

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      break;
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  // commit('update', err);
  return err;
}

const actions = {
  async fetchReports({ commit }, { form = {}, forced = false } = {}) {
    commit('beforeReportsLoading', forced);
    try {
      const { data } = await ApiService.post(`${endpoint}/all`, form);
      commit('reports', { data });
      return data;
    } catch (error) {
      commit('reports', { error });
      throw handleApiError(commit, error);
    }
  },

  async fetchProperties({ commit }, { search } = {}) {
    try {
      const payload = {
        search,
      };
      const { data } = await ApiService.post(`${endpoint}/properties`, payload);
      commit('properties', data);
      return data;
    } catch (error) {
      commit('properties', { error });
      throw handleApiError(commit, error);
    }
  },
  async fetchUsers({ commit }, { search, propertyId } = {}) {
    try {
      const payload = {
        search,
        propertyId,
      };
      const { data } = await ApiService.post(`${endpoint}/users`, payload);
      commit('users', data);
      return data;
    } catch (error) {
      commit('properties', { error });
      throw handleApiError(commit, error);
    }
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
